import React from 'react';
import { TimeUnit } from 'framework/forms/TimeUnit';
import { ITimeUnitTranslation } from '../timeUnit/ITimeUnitTranslation';

interface IRecordContext {
    timeUnitRecord: Record<TimeUnit, ITimeUnitTranslation>;
}

export const RecordContext = React.createContext<IRecordContext>(undefined as any);
